import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { ScheduleWorkingRoutesNodesListInterface } from "../../../redux/interfaces/expedition.interface";
import ModalList, {
  ModalListItem,
} from "../../../components/misc/ModalList/ModalList";
import {
  fetchAwbHistory,
  fetchTransferNode,
  getWorkingRoutesNodes,
} from "../../../redux/api/expedition.api";
import CustomButton from "../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import {
  clearWorkingRoutesNodes,
  setClientsSelectedActiveExpeditionForNode,
} from "../../../redux/reducer/expedition.reducer";
import useRoutesHelper from "../../../hooks/useRoutesHelper";
import useTableCtx from "../../../components/tables/tableContext/useTableCtx";

function NodeTransferActiveExpeditionModal() {
  const dispatch = useAppDispatch();
  const { setSelectedItems } = useTableCtx() || {};

  const { routeParams } = useRoutesHelper();

  const {
    expedition: {
      workingRoutesNodes: {
        data: { data: clientsNodesData },
      },
      clientsSelectedActiveExpeditionForNode,
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const [selectedNode, setSelectedNode] =
    useState<ScheduleWorkingRoutesNodesListInterface | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (clientsSelectedActiveExpeditionForNode?.[0]?.id_nod) {
      const initialSelectedNode = clientsNodesData.find(
        (node) =>
          node.id_nod === clientsSelectedActiveExpeditionForNode?.[0]?.id_nod,
      );
      if (initialSelectedNode) {
        setSelectedNode(initialSelectedNode);
      }
    }
  }, [clientsNodesData, clientsSelectedActiveExpeditionForNode]);

  useEffect(() => {
    return () => {
      dispatch(clearWorkingRoutesNodes());
      setSelectedNode(null);
    };
  }, [dispatch]);

  const initialClientsNodesList: ModalListItem[] = useMemo(
    () =>
      clientsNodesData.map((item) => {
        const { id_nod: id, nodNume: label } = item;
        return {
          ...item,
          label: `${label}`, // required
          id: id, // required
          backgroundColor: id === selectedNode?.id_nod ? "warning" : "info",
        };
      }),
    [clientsNodesData, selectedNode?.id_nod],
  );

  const workingNodesModalActions = useCallback(() => {
    if (clientsSelectedActiveExpeditionForNode?.length) {
      dispatch(
        getWorkingRoutesNodes({
          page: 1,
          perPage: 50,
        }),
      );
    }
  }, [clientsSelectedActiveExpeditionForNode, dispatch]);

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!clientsSelectedActiveExpeditionForNode || !selectedNode) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        fetchTransferNode({
          selectedActiveExpeditions: clientsSelectedActiveExpeditionForNode,
          id_nod: selectedNode.id_nod,
          id_client: "all",
        }),
      );

      if (
        checkEndpointStatus(resultAction, fetchTransferNode) !==
        endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(resultAction, fetchTransferNode) ===
        endpointStatus.fulfilled
      ) {
        const {
          client,
          doc_trans,
          nodDestinatie,
          pctlivrare,
          route,
          status,
          page,
          rowsPerPage,
        } = routeParams;

        dispatch(
          fetchAwbHistory({
            page: page,
            perPage: rowsPerPage,
            doc_trans: doc_trans,
            nodDestinatie: nodDestinatie,
            pctlivrare: pctlivrare,
            status: status,
            id_client: client,
            route: route,
          }),
        );
        setSelectedItems && setSelectedItems([]);

        handleClose && handleClose();
      }
    },
    [
      clientsSelectedActiveExpeditionForNode,
      dispatch,
      routeParams,
      selectedNode,
      setSelectedItems,
    ],
  );

  const onClose = useCallback(() => {
    dispatch(setClientsSelectedActiveExpeditionForNode([]));
    dispatch(clearWorkingRoutesNodes());
    setSelectedItems && setSelectedItems([]);
    setSelectedNode(null);
  }, [dispatch, setSelectedItems]);

  return (
    <ModalList
      dynamicModalOpen={clientsSelectedActiveExpeditionForNode.length > 0}
      withSearch={false}
      onClose={onClose}
      label="Schimbare nod"
      modalTitle={"Schimbare nod"}
      searchPlaceholder={"Cauta nod"}
      items={initialClientsNodesList}
      modalActions={workingNodesModalActions}
      selectedItem={{
        id: selectedNode?.id_nod || "",
        label: selectedNode?.nodNume || "",
      }}
      setSelectedItem={setSelectedNode}
      withCloseAfterSelect={false}
      CustomModalFooter={({ handleClose }: any) => (
        <div className="flex justify-between gap-4">
          <CustomButton onClick={handleClose}>Inapoi</CustomButton>
          <CustomButton
            variant="contained"
            loading={isLoading}
            onClick={() => {
              handleOnSubmit({ handleClose });
            }}>
            Salveaza
          </CustomButton>
        </div>
      )}
      CustomOpenModalComponent={() => <></>}
    />
  );
}

export default NodeTransferActiveExpeditionModal;
